import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TdsPreviewModal from '../components/tds/TdsPreviewModal';

/** Direct link /tds/:code — SEO URLs; closes back to catalog */
const TdsDetailPage = () => {
  const { code: slugParam } = useParams();
  const navigate = useNavigate();

  return <TdsPreviewModal slug={slugParam} onClose={() => navigate('/tds')} />;
};

export default TdsDetailPage;
